module.exports = __webpack_public_path__ + "img/7.c6aa4d91.png";